import { Injectable, Injector } from '@angular/core';
import { BitfAdfsAuthService } from '@bitf/services/auth/adfs/bitf-adfs-auth.service';
import { IBitfApiResponse } from '@common/interfaces';
import { BitfTryCatch } from '@common/libs/bitforce/core/decorators';
import { BITF_CONFIGS } from '@configs';
import { EBitfAuthState } from '@enums';
import { environment } from '@env/environment';
import { User } from '@web/core/models';
import { StorageService } from '@web/core/services';
import { AdfsService } from './adfs.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BitfAdfsAuthService {
  tokenAlertTresholdMinutes = 5;
  constructor(protected injector: Injector) {
    super(injector);
  }

  handleRedirect() {
    this.router.navigate([BITF_CONFIGS.urls.homePageUrl]);
  }

  logout() {
    this.storeService.resetStore();
    this.storageService.clearData();
  }
}
